import { fetchApi } from '@/config/axiosSetting';
import { PatchVehicleInformationAfterInquiryType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVehicleInformationAfterInquiry/patchVehicleInformationAfterInquiry.type';

export const patchInitialVehicleInformationAfterInquiryFunction = ({
  id,
  data,
}: PatchVehicleInformationAfterInquiryType) => {
  return fetchApi.patch(`/initial/reports/${id}/vehicle_information/`, {
    ...data,
    id,
  });
};
